import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Vessel } from '../dto/vessel';

@Injectable({
  providedIn: 'root'
})
export class VesselService {

  private apiUrl = environment.apiRoot + '/vessel';

  constructor(private http: HttpClient) { }

  getAllVesselsOfCustomer(customerId: number): Observable<Vessel[]> {
    return this.http.get<Vessel[]>(this.apiUrl + '/allofcustomer?customerId=' + customerId);
  }

  getVesselById(vesselId: number): Observable<Vessel> {
    return this.http.get<Vessel>(this.apiUrl + '/details?vesselId=' + vesselId);
  }

  createVessel(vesselId: number): Observable<Vessel> {
    let model = { "id": 0, "customer_id": vesselId, "name": "new vessel" };
    return this.http.post<Vessel>(this.apiUrl + '/new', model);
  }

  updateVessel(model: Vessel): Observable<Vessel> {
    return this.http.put<Vessel>(this.apiUrl + '/update', model);
  }

  deleteVessel(vesselId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?vesselId=' + vesselId);
  }
}
